module.exports = __webpack_public_path__ + "img/labvida.5fa58799.svg";